import React, { useEffect, useRef, useState } from 'react';
import connect from '../views/axios/axios.auth';

const UsuariosSelect = ({ onSelected, reset }) => {

  const select = useRef();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    select.current.selectedIndex = 0;
  },[reset]);

  useEffect(() => {
    getUsersList();
  },[]);

  const getUsersList = () => {
    connect.get('/users/list').then((response) => {
      const data = response.data;
      setUsers(data.response);
    })
  }

  const sendData = (e) => {
    const id = e.target.value;
    let data = { id: 'null', username: 'Todos' };
    if (id !== 'null') {
     data = users.filter(e => e.id === parseInt(id))[0];  
    }
    onSelected(data);
  }

  return (
      <select ref={select} onChange={sendData} className="form-control">
      <option value="null">Todos</option>
      {users.map((item, i) => {
        return <option key={i} value={item.id}>{item.username.toUpperCase()}</option>
      })}
      </select>
  )
};

export default UsuariosSelect;